import React, { useRef, useState } from "react";
import { StyleSheet, Text, View, Dimensions, Pressable, FlatList, Animated, SafeAreaView } from 'react-native';
import { NavigationContainer } from '@react-navigation/native';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import Ionicons from 'react-native-vector-icons/Ionicons';
import { useKeepAwake } from 'expo-keep-awake';

import HomeScreen from './components/HomeScreen';
import SkillsScreen from './components/SkillsScreen';
import LogScreen from './components/LogScreen';
import OptionsScreen from './components/OptionsScreen';
import ObjectiveScreen from './components/ObjectiveScreen';

const Tab = createBottomTabNavigator();

function ArtifactsScreen() {
	//useKeepAwake();
  return (
    <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
      <Text>Artifacts!</Text>
    </View>
  );
}

function MyTabs() {
  return (
    <Tab.Navigator initialRouteName="Home" backBehavior="initialRoute" screenOptions={{tabBarStyle: styles.navigationBar}}>
    <Tab.Screen name="Log" component={LogScreen} options={{headerShown:false,
      tabBarLabel:() => {return null},
      tabBarIcon: (tabInfo) => {
        return (
          <Ionicons
            name="md-book-outline"
            size={24}
            color={tabInfo.focused ? "#f44336" : "#ffffff"}
          />
        );}}}/>
    <Tab.Screen name="Skills" component={SkillsScreen} options={{headerShown:false,
      tabBarLabel:() => {return null},
      tabBarIcon: (tabInfo) => {
        return (
          <Ionicons
            name="md-water-outline"
            size={24}
            color={tabInfo.focused ? "#f44336" : "#ffffff"}
          />
        );}}}/>
      <Tab.Screen name="Home" component={HomeScreen} options={{headerShown:false,
      tabBarLabel:() => {return null},
      tabBarIcon: (tabInfo) => {
        return (
          <Ionicons
            name="md-skull-outline"
            size={24}
            color={tabInfo.focused ? "#f44336" : "#ffffff"}
          />
        );}}}/>
      <Tab.Screen name="Ambitions" component={ObjectiveScreen} options={{headerShown:false,
      tabBarLabel:() => {return null},
      tabBarIcon: (tabInfo) => {
        return (
          <Ionicons
            name="md-flame-outline"
            size={24}
            color={tabInfo.focused ? "#f44336" : "#ffffff"}
          />
        );}}}/>
      <Tab.Screen name="Options" component={OptionsScreen} options={{headerShown:false,
      tabBarLabel:() => {return null},
      tabBarIcon: (tabInfo) => {
        return (
          <Ionicons
            name="md-settings-outline"
            size={24}
            color={tabInfo.focused ? "#f44336" : "#ffffff"}
          />
        );}}}/>
    </Tab.Navigator>
  );
}

export default function App() {
	//useKeepAwake();
  return (
    <NavigationContainer documentTitle={{
        enabled: false,
      }}>
      <MyTabs />
    </NavigationContainer>
  );
}


const styles = StyleSheet.create({
	
  container: {
	flex: 1,
    maxWidth: 600,
  },
	
  navigationBar: {
    backgroundColor: '#000',
  },
});
